import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { getAuthProvider } from '@/auth/auth-provider';
import { useAppDispatch } from '@/store';
import { actions } from '@/store/actions';

export const useFetchApp = () => {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  const apiClient = useChatApiClient();

  const fetchApp = (brandIdentifier: string, applicationIdentifier: string) => {
    dispatch(actions.appStateLoadStarted());

    apiClient.app.getAppState(brandIdentifier, applicationIdentifier)
      .then(data => {
        if (data.session && getAuthProvider().authSource === 'cookie') {
          getAuthProvider().authenticate({
            authSource: 'cookie',
            sessionMeta: {
              authenticated: data.session.authenticated,
              expiry: data.session.expiry,
            },
          });
        }
        // hack for now until refactor
        queryClient.refetchQueries({
          queryKey: ['get:app/theming'],
        })
          .then(() => {
            setTimeout(() => {
              dispatch(actions.appStatedLoaded({
                copilot: data.copilot,
                features: data.features,
                settings: data.settings,
                group: data.group,
                user: {
                  identifier: data.user.identifier,
                  id: data.user.id,
                  username: data.user.username || data.user.email,
                  email: data.user.email,
                  profile: {
                    name: data.user.name,
                    firstName: data.user.firstName,
                    lastName: data.user.lastName,
                    photoUrl: data.user.photoUrl,
                  },
                  permissions: data.user.permissions,
                  roles: data.user.roles,
                  isFirstSession: data.user.isFirstSession,
                },
                workspace: data.workspace,
              }));
            }, 0);
          });
      })
      .catch((e: Error) => {
        dispatch(actions.appStateLoadError({ error: e }));
      });
  };

  return useCallback(fetchApp, [
    queryClient,
    dispatch,
  ]);
};